import { createBusinessLogger } from '@/utils/logger/businessLogger';

// 售后 事件名称常量
export const AFTERSALES_EVENT_NAMES = {
  AFTERSALES_LIST_PAGE_LOAD_FAIL: 'afterSales_list_page_load_fail', // 售后单列表异常
  AFTERSALES_DETAIL_PAGE_LOAD_FAIL: 'afterSales_detail_page_load_fail', // 售后单详情异常
  AFTERSALES_APPLY_FAIL: 'afterSales_apply_fail', // 售后单提交申请异常
  AFTERSALES_RETURN_PRODUCT_FAIL: 'afterSales_return_product_fail', // 售后单可售后商品列表异常
} as const;

// 导出类型定义，既可以当常量用也可以当类型用
export type AfterSalesEventNames = typeof AFTERSALES_EVENT_NAMES;

// 暂时不需要分类，之后有需要再添加
const categoryNames: string[] = [];

// Business Logger 实例 - 售后
export const afterSalesBusinessLogger = createBusinessLogger<AfterSalesEventNames>(
  'afterSales',
  categoryNames,
);
